export interface CommercialContactPersonSource {
  contactType?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  title?: string | null;
  companyName?: string | null;
  displayName?: string | null;
}

export interface CommercialPrimaryContact {
  name: string;
  title?: string;
}

/** Resolve the human stored on a commercial account/location. */
export function getCommercialPrimaryContact(
  contact?: CommercialContactPersonSource | null,
): CommercialPrimaryContact | null {
  if (!contact || contact.contactType === 'RESIDENTIAL') return null;

  const name = [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim();
  const title = contact.title?.trim() || undefined;
  const accountName = contact.companyName?.trim() || contact.displayName?.trim() || '';
  const nameIsAccount =
    Boolean(name) && Boolean(accountName) && name.toLowerCase() === accountName.toLowerCase();

  // This helper feeds persisted estimate/visit snapshots as well as labels.
  // Never manufacture a person name from a title-only record: placeholders
  // belong in presentation code, not customer data that survives a save.
  if (!name || nameIsAccount) return null;
  return { name, title };
}
